import React from 'react';
import { StyleSheet, css } from 'aphrodite';

import { white } from 'shared/colors';
import { BREAKPOINTS } from 'shared/constants';
import { convertToMobileVW, convertToVW } from 'shared/utils';

interface Props {
  name: string;
  description: string;
  isSingle?: boolean;
}

const ShopFlavorTitle = ({ name, description, isSingle }: Props) => {
  return (
    <div className={css(styles.title, isSingle && styles.fullHeight)}>
      <h2 className={css(styles.flavorName)}>{name}</h2>
      <p className={css(styles.flavorDescription)}>{description}</p>
    </div>
  );
};

export default ShopFlavorTitle;

const styles = StyleSheet.create({
  title: {
    width: '100%',
    padding: `100px 20px 20px 20px`,
    borderBottom: `1px solid ${white}`,
    [BREAKPOINTS.TABLET]: {},
  },
  flavorName: {
    fontFamily: 'Titling Gothic FB Compressed',
    fontSize: '50px',
    marginBottom: '1.25rem',
    [BREAKPOINTS.TABLET]: {},
    [BREAKPOINTS.MOBILE]: {},
  },
  flavorDescription: {
    fontFamily: 'Titling Gothic FB Normal Regular',
    fontSize: '12px',
    lineHeight: '1.5',
    maxWidth: '45vw',
    [BREAKPOINTS.TABLET]: {
      maxWidth: '95vw',
    },
    [BREAKPOINTS.MOBILE]: {},
  },
  fullHeight: {
    height: '100%',
  },
});
